import { render, staticRenderFns } from "./CustomersSubscriptionCharge.vue?vue&type=template&id=3160a50c"
import script from "./CustomersSubscriptionCharge.vue?vue&type=script&lang=js"
export * from "./CustomersSubscriptionCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports